import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer/Footer";
import InfoCard from "../../components/Dashboard/InfoCard";
import CareTeamCard from "../../components/Dashboard/CareTeamCard";
import { getUserProfile } from '../../api/userProfileApi';
import { fetchHealthData } from '../../api/healthDataApi';
import { getMedicalConditions } from '../../api/medicalConditionApi';
import { getMedicalHistory } from '../../api/medicalHistoryApi';

export default function UserProfile() {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [healthData, setHealthData] = useState(null);
  const [medicalConditions, setMedicalConditions] = useState([]);
  const [medicalHistory, setMedicalHistory] = useState([]);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      return;
    }
    axios.get(`api/user/${userId}`)
      .then(response => {
        console.log("Full user data array:", response.data);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setUser(response.data[0]); // only display first in array
        } else {
          console.warn("No user data found");
        }
      })
      .catch(error => {
        console.error("Error fetching user:", error);
      });
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        return;
      }
      const data = await getUserProfile(userId);
      setProfile(data);
    };
    fetchProfile();
  }, []);

  useEffect(() => {
    const fetchHealthInfo = async () => {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        return;
      }

      const data = await fetchHealthData(userId);
      setHealthData(data);
    }

    fetchHealthInfo();
  }, [])

  useEffect(() => {
    const fetchMedicalConditions = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        return;
      }
      try {
        const data = await getMedicalConditions(userId);
        setMedicalConditions(data);
      } catch (error) {
        console.error("Error fetching medical conditions:", error);
      }
    };
    fetchMedicalConditions();
  }, []);

  useEffect(() => {
    const fetchMedicalHistory = async () => {
      const userId = localStorage.getItem("userId");
      if (!userId) {
        return;
      }
      try {
        const data = await getMedicalHistory(userId);
        setMedicalHistory(data);
      } catch (error) {
        console.error("Error fetching medical history:", error);
      }
    };
    fetchMedicalHistory();
  }, []);
  return (
    <div className={`ml-0 flex flex-col min-h-screen transition-all duration-300 ${sidebarExpanded ? 'md:ml-56' : 'md:ml-16'}`}>
      <Sidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />

      <main className="flex-1 p-6 overflow-auto bg-gray-100">
        <h2 className="text-2xl font-bold text-[#04395b] mb-6">User Profile</h2>

        {/* User Info */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-6 mb-10 p-6 bg-white rounded-lg">
          <img
            src="/img_8916.png"
            alt="Profile"
            className="w-24 h-24"
          />
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-[#04395b]">{user ? `${user.first_name} ${user.last_name}` : 'Loading...'}</h3>
            <p className="text-gray-500 mt-1">{user?.email}</p>
            <p className="text-gray-500">{user?.phone_number}</p>
            <p className="text-gray-500">DOB: {user ? new Date(user.dob).toLocaleDateString() : 'N/A'}</p>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <InfoCard title="Personal Information">
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              <div>
                <span className="font-semibold">Age:</span> {profile && profile.age ? profile.age : 'N/A'}
              </div>
              <div>
                <span className="font-semibold">Weight:</span> {profile && profile.weight_lbs ? `${profile.weight_lbs} lbs` : 'N/A'}
              </div>
              <div>
                <span className="font-semibold">Height:</span> {profile && profile.height_cm ? `${profile.height_cm} cm` : 'N/A'}
              </div>
              <div>
                <span className="font-semibold">Blood Type:</span> {profile && profile.blood_type ? profile.blood_type : 'N/A'}
              </div>
              <div>
                <span className="font-semibold">Sex:</span> {profile && profile.sex ? profile.sex : 'N/A'}
              </div>
              <div>
                <span className="font-semibold">Allergies:</span> {profile && profile.allergies ? profile.allergies : 'None'}
              </div>
            </div>
          </InfoCard>

          <CareTeamCard />

          <InfoCard title="Insurance Information">
            <p>{profile && profile.insurance_info ? profile.insurance_info : 'N/A'}</p>
          </InfoCard>

          <InfoCard title="Chronic Medical Conditions">
            {medicalConditions && medicalConditions.length > 0 ? (
              <ul className="list-disc list-inside">
                {medicalConditions.map((condition) => (
                  <li key={condition.id}>
                    {condition.condition_name}
                    {condition.diagnosis_date && ` - Diagnosed: ${new Date(condition.diagnosis_date).toLocaleDateString()}`}
                  </li>
                ))}
              </ul>
            ) : (
              <p>N/A</p>
            )}
          </InfoCard>

          <InfoCard title="Medical History">
            {medicalHistory && medicalHistory.length > 0 ? (
              <ul className="list-disc list-inside">
                {medicalHistory.map((condition) => (
                  <li key={condition.id}>
                    {condition.condition_name}
                    {condition.diagnosis_date && ` - Diagnosed: ${new Date(condition.diagnosis_date).toLocaleDateString()}`}
                  </li>
                ))}
              </ul>
            ) : (
              <p>N/A</p>
            )}
          </InfoCard>

          <InfoCard title="Family History">
            {healthData && healthData.family_history ? (
              <ul className="list-disc list-inside">
                {healthData.family_history
                  .split(',')
                  .map((condition, index) => (
                    <li key={index}>{condition.trim()}</li>
                  ))}
              </ul>
            ) : (
              <p>N/A</p>
            )}
          </InfoCard>
          <InfoCard title="Preferred Pharmacy">
            <p>{profile && profile.pharmacy_info ? profile.pharmacy_info : 'N/A'}</p>
          </InfoCard>

          <InfoCard title="Emergency Contact">
            {profile && profile.emergency_name ? (
              <div className="space-y-1">
                <p><span className="font-semibold">Name:</span> {profile.emergency_name}</p>
                <p><span className="font-semibold">Phone:</span> {profile.emergency_phone || 'N/A'}</p>
                <p><span className="font-semibold">Relation:</span> {profile.emergency_relation || 'N/A'}</p>
              </div>
            ) : (
              <p>N/A</p>
            )}
          </InfoCard>

        </div>
      </main>

      <Footer />
    </div>
  );
}
